package fr.anthony.abkweb.model

data class Expertise(
    val title: String,
    val description: String
)
